<template>
<div class="flex shadow-2xl">
      <div class="tab-content p-4 flex-grow bg-white rounded-r">
            <loader v-if="isLoading" :show="!!isLoading"></loader>
            <template v-else>
                  <TabSelectReport v-show="activeTab == 0" />
                  <TabOutline v-show="activeTab == 1" />
                  <TabFilters 
                        :filtersList="filtersList" 
                        :filterOptions="filterOptions"
                        :date_from="dateFrom"
                        :date_to="dateTo"
                        :backward_interval="backwardInterval"
                        :cover_type="coverType"
                        @update="updateFilters($event)" 
                        v-show="activeTab == 2"
                  />
                  <TabAddons v-show="activeTab == 3" />
            </template>
      </div>
</div>
</template>

<script>
import TabAddons from './TabAddons.vue'
import TabFilters from './TabFilters.vue'
import TabOutline from './TabOutline.vue'
import TabSelectReport from './TabSelectReport.vue'
import {mapGetters, mapMutations, mapActions} from 'vuex'
import Loader from '../Loader.vue'
export default {
      name: 'tableWrapper',
      components: {
            TabSelectReport,
            TabOutline,
            TabFilters,
            TabAddons,
            Loader,
      },
      data(){
            return {
                  tabs: ['Select report', 'Outline', 'Filters', 'Addons' ],
                  tabs_names: ['select_report', 'outline', 'filters', 'addons'],
                  isReportEditable: false
                  // tabs_translations: [$t('select_report'), $t('outline'), $t('filters'), $t('addons') ],
                  // tabs: [
                  //       { 
                  //             name: 'Select report', 
                  //             label: $t('select_report')
                  //       },{ 
                  //             name: 'Outline', 
                  //             label: $t('outline')
                  //       },{ 
                  //             name: 'Filters', 
                  //             label: $t('filters')
                  //       },{ 
                  //             name: 'Addons', 
                  //             label: $t('addons')
                  //       }
                  // ]
            }
      },
      computed: {
            ...mapGetters(['activeTab','newReport','isLoading','activeReport', 'allColumns','findReport']),
            isReportSelected(){
              this.checkEditable()
              if(this.activeReport.report) return true
              else return false
            },
            isDerived() {
              if(this.activeReport.report !== null){
                const report = this.findReport((this.activeReport.report))
                return report.derived
              }
              return false
            },
            filtersList() {
                  return this.newReport.filters ? this.newReport.filters : []
            },
            filterOptions (){
              return this.allColumns.filter(column => {
                return this.newReport.service_name == column.service
              }).map(column => {
                return {name: column.name, type: column.type, label: this.$t(column.name, 1)}
              })
            },
            dateFrom(){
                  return this.newReport.date_from
            },
            dateTo(){
                  return this.newReport.date_to
            },
            backwardInterval(){
                  return this.newReport.backward_interval
            },
            coverType(){
                  return this.newReport.cover_type
            },
      },
      methods: {
            ...mapMutations({
                  setActiveTab: 'setActiveTab',
                  setNewReportItem: 'setNewReportItem',
            }),
            ...mapActions({
                  generateReport: 'generateReport',
                  getReports: 'getReports',
            }),
            updateFilters(event) {
                  this.setNewReportItem(event)
              this.$forceUpdate();
            },
            changeTab(index){
                  if(this.isReportSelected && this.isReportEditable){
                        this.setActiveTab(index)
                  }
            },
            checkEditable(){
              if(this.activeReport.report !== null){
                const report = this.findReport((this.activeReport.report))
                if((report.editPermission === null ||
                    report.editPermission === true)
                ) {
                  this.isReportEditable = true
                  return
                }
              }
              this.isReportEditable = false
            },
            goto(el){
                  if(this.isReportSelected){
                        const payload = {
                              backward_interval: this.newReport.backward_interval,
                              columns: this.newReport.view_columns_stringify,
                              filters: this.newReport.filters_stringify,
                              group_by: this.newReport.group_by_stringify,
                              stack_by: this.newReport.stack_by_stringify,
                              order_by: this.newReport.order_by_stringify,
                              date_from: this.newReport.date_from,
                              date_to: this.newReport.date_to,
                              cover_type: this.newReport.cover_type,
                              chart_id: this.newReport.chart_id,
                              map: this.newReport.map ? this.newReport.map : false,
                              service: this.newReport.service_name,
                              aggregate: this.newReport.aggregate ? this.newReport.aggregate_stringify : null,
                              additionalGroupBy: this.newReport.additionalGroupBy ? this.newReport.additionalGroupBy_stringify : null
                        }
                        this.generateReport(payload).then(()=> {
                              document.getElementById(el).scrollIntoView({behavior: 'smooth', block: 'start', inline: 'center'})
                        })
                  }
            }
      },
      created(){
        this.getReports()
      }
}
</script>

<style lang="sass" scoped>
.tabs
      .active
            background-color: white
</style>
